<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '43',
	},
	height: {
		type: String,
		default: '42',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 43 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="Vector">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M13.6738 0.287706C13.4711 0.401063 13.3351 0.616295 13.3369 0.860676C13.3402 1.15305 13.5417 1.39979 13.8161 1.47958C13.8429 1.48694 14.7193 1.65064 14.7193 1.65064C14.9886 1.71689 15.1669 1.92565 15.1711 2.20654C15.1732 2.48831 14.9778 2.65967 14.8982 2.69677C12.2419 4.29231 0.0878813 7.66565 0.251639 22.5614C0.344526 30.9295 6.24675 38.6926 11.8779 40.9591C13.491 41.6075 14.7881 41.3578 14.8294 40.8643C14.8517 40.5923 14.1816 39.4767 14.1816 39.4767C12.032 35.9393 9.87838 31.0658 9.1389 24.5759C8.71186 20.851 7.73987 10.2405 22.0103 10.1463C28.8547 10.1006 34.9333 14.5854 34.1878 22.9539C33.6185 29.3131 28.7027 33.4964 21.0495 33.9398C20.1719 33.9887 19.4032 34.8178 19.7759 35.8695C20.355 37.5092 22.0737 42.6103 25.6573 41.9396C35.1405 39.7729 42.3585 32.4282 42.2488 22.4524C42.0935 8.24186 29.1626 -0.129508 16.613 0.00151554C14.1626 0.0277202 13.7329 0.254729 13.6738 0.287706Z"
				fill="#56AB48"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.6749 27.8333C25.5688 27.405 27.3489 24.4805 27.5711 22.0424C27.8147 19.3575 25.655 15.6144 21.5757 16.1461C15.7356 16.9054 16.0165 20.9314 16.1484 22.5046C16.2508 23.727 16.5001 24.822 16.8587 25.754C17.2568 26.7839 18.2711 27.9355 19.6749 27.8333Z"
				fill="#56AB48"
			/>
		</g>
	</svg>
</template>
